import { DEV } from 'js/utils/constants/dev'
import { useStorage } from '@vueuse/core'
import { watch } from 'vue'

export function useDevTricks() {
  const config = useStorage('config-store', {
    showFloatCard: true,
    persticide: false,
    cache: {
      persistent: true,
      clearOnMutation: true,
    },
  })

  function enablePesticide(v) {
    if (document.getElementById('pesticide-style')) {
      document.getElementById('pesticide-style').remove()
      console.log('Pesticide desativado')
      return
    }
    if (!v) return
    setTimeout(() => {
      const colors = [
        'rgba(255, 0, 0, 0.7)', // vermelho
        'rgba(0, 255, 0, 0.7)', // verde
        'rgba(0, 0, 255, 0.7)', // azul
        'rgba(255, 165, 0, 0.7)', // laranja
        'rgba(255, 0, 255, 0.7)', // magenta
        'rgba(0, 255, 255, 0.7)', // ciano
      ]

      // Gera CSS para cada nível de profundidade  (ajustável)
      let css = ''
      for (let level = 1; level <= 20; level++) {
        let color = colors[(level - 1) % colors.length]
        let selector = 'body'

        // concatena o seletor filho " > *" n vezes (level-1 vezes)
        for (let i = 1; i < level; i++) {
          selector += ' > *'
        }

        css += `
      ${selector} {
        outline: 1px solid ${color} !important;
      }
    `
      }

      const style = document.createElement('style')
      style.id = 'pesticide-style'
      style.textContent = css
      document.head.appendChild(style)

      console.log('Pesticide ativado - outlines coloridos por nível')
    }, 300)
  }

  watch(
    () => config.value.persticide,
    (v) => {
      enablePesticide(v)
    },
    { immediate: true }
  )

  return {
    config,
    DEV,
  }
}
